"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequest = exports.getNotices = exports.getComponentRoutings = void 0;
const common_1 = require("@finley-technologies/common");
// Helper method
const mapComponentRoutings = (fundingRequestComponentType, sourceAccounts, destinationAccounts) => {
    const componentRoutings = [];
    (0, common_1.finleyAssert)(sourceAccounts &&
        sourceAccounts.contents.length > 0 &&
        destinationAccounts &&
        destinationAccounts.contents.length > 0, `Source and destination accounts must be defined for all funding request components within credit agreement.`);
    sourceAccounts.contents.forEach((sourceAccount) => {
        destinationAccounts.contents.forEach((destinationAccount) => {
            componentRoutings.push({
                type: fundingRequestComponentType,
                sourceBankAccountId: sourceAccount.value,
                destinationBankAccountId: destinationAccount.value,
            });
        });
    });
    return componentRoutings;
};
const getComponentRoutings = (fundingRequestMechanics) => {
    const routings = [];
    const { collectionsPaydown, collectionsRecycle, curePaydown, drawRequest, } = fundingRequestMechanics;
    routings.push(...mapComponentRoutings('collectionsPaydown', collectionsPaydown.sourceAccounts, collectionsPaydown.destinationAccounts));
    routings.push(...mapComponentRoutings('collectionsRecycle', collectionsRecycle.sourceAccounts, collectionsRecycle.destinationAccounts));
    routings.push(...mapComponentRoutings('curePaydown', curePaydown.sourceAccounts, curePaydown.destinationAccounts));
    routings.push(...mapComponentRoutings('drawRequest', drawRequest.sourceAccounts, drawRequest.destinationAccounts));
    return { routings };
};
exports.getComponentRoutings = getComponentRoutings;
const getNotices = (reportingMechanics) => {
    const notices = reportingMechanics
        .filter((report) => report.reportConfigTypes.some((configType) => configType === 'fundingNotice'))
        .map((report) => {
        const { _config_: config } = report;
        const componentTypes = [];
        (0, common_1.finleyAssert)(config.type === 'docx', 'Only docx configuration type is supported to get funding notice.');
        if (config.output.fundingRequestComponents) {
            for (const [key, required] of Object.entries(config.output.fundingRequestComponents)) {
                if (required) {
                    const componentType = key;
                    componentTypes.push(componentType);
                }
            }
        }
        return {
            reportName: config.output.name,
            componentTypes,
        };
    });
    return { notices };
};
exports.getNotices = getNotices;
const getRequest = (fundingRequestMechanics, reportingMechanics) => {
    const { routings } = (0, exports.getComponentRoutings)(fundingRequestMechanics);
    const { notices } = (0, exports.getNotices)(reportingMechanics);
    // Global constraint handling
    // Cash
    // Collections recycle
    // Loans
    // Draw request
    // TODO: future changes to accommodate repayment flow
    // Collections paydown
    // Cure paydown
    return {
        request: { draw: {}, recycle: {}, routings, notices },
    };
};
exports.getRequest = getRequest;
//# sourceMappingURL=request.js.map